import React from "react";
import { Link } from "react-router-dom";


export default function MH20ER4534() {
    return (
        <div className="mh-container my-4">
            {/* Header */}
            <div className="special-header d-flex justify-content-between">
                <h4 className=" page-title pt-2">Vehicle Fuel Details</h4>
                <div className="d-flex align-items-center gap-2">
                    <Link to="/accountant/updatevehiclemaintenance" type="button" className="btn custom-btn">Edit</Link>
                    <Link to="/createvehiclefuel" type="button" className="btn custom-btn">Delete</Link>
                </div>
            </div>

            {/* Table */}
            <div className="card col-md-12">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="custom-table p-10 table-bordered mb-0">
                            <tbody>
                                <tr>

                                    <td style={{ width: "500px" }}>Bus Code</td>
                                    <td>MH20ER4534</td>

                                </tr>
                                <tr>

                                    <td>Maintenance Task</td>
                                    <td>Servicing</td>

                                </tr>
                                <tr>

                                    <td>Schedule Duration(H)</td>
                                    <td>4</td>

                                </tr>
                                <tr>

                                    <td>Start Date</td>
                                    <td>Sat May 10 2025</td>

                                </tr>
                                <tr>

                                    <td>Next Due Date / Mileage</td>
                                    <td>Mon May 12 2025</td>

                                </tr>

                                 <tr>

                                    <td>Type of Task</td>
                                    <td>Instant</td>

                                </tr>

                                 <tr>

                                    <td>Off-Road</td>
                                    <td>Enabled</td>

                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    );

}